import React from 'react';

export const Logo = ({ className = '', size = 'default' }) => {
    const sizes = {
        small: 'h-6',
        default: 'h-8',
        large: 'h-12',
    };

    return (
        <div className={`flex items-center ${className}`}>
            <img 
                src="https://customer-assets.emergentagent.com/job_abm-dashboard-1/artifacts/i6frhtu5_NovantPro%20Logo%20White%20New.png"
                alt="NovantPro"
                className={`${sizes[size]} w-auto object-contain`}
            />
        </div>
    );
};

export default Logo;
